/**
 * Flow names shared by more than one file.
 *
 * A flow's five events are keyed off this string, so a typo in one of the
 * screens that make up a flow silently forks the funnel rather than failing.
 * Anything spanning two files names itself here; a flow contained in a single
 * file can keep its name local.
 */

/**
 * Accepting a partner's invitation, from opening the link through the partner
 * link being established.
 *
 * It deliberately overlaps the onboarding funnel rather than replacing it: the
 * two answer different questions. `onboarding_*` asks how many people who
 * started signup finished it. `invite_accept_*` asks how many people who were
 * invited ended up linked — and its top step, someone opening a broken or
 * expired link, never reaches onboarding at all.
 */
export const INVITE_ACCEPT_FLOW = "invite_accept";
